import axios from 'axios';

const API = `${process.env.REACT_APP_BACKEND_URL}/api`;

// Generate or get session ID
const getSessionId = () => {
  let sessionId = sessionStorage.getItem('analytics_session_id');
  if (!sessionId) {
    sessionId = `session_${Date.now()}_${Math.random().toString(36).substr(2, 9)}`;
    sessionStorage.setItem('analytics_session_id', sessionId);
  }
  return sessionId;
};

// Track page view
export const trackPageView = async (pageUrl, pageTitle) => {
  try {
    const sessionId = getSessionId();
    
    await axios.post(`${API}/analytics/track`, {
      page_url: pageUrl,
      page_title: pageTitle,
      referrer: document.referrer || null,
      user_agent: navigator.userAgent,
      session_id: sessionId,
      timestamp: new Date().toISOString()
    });
  } catch (error) {
    // Silently fail - don't break the app if analytics fails
    console.debug('Analytics tracking failed:', error);
  }
};

// Hook to use in components
export const usePageTracking = () => {
  return { trackPageView };
};
